__turbopack_context__.v({
  "active": "styles-module-scss-module__KiSToW__active",
  "button": "styles-module-scss-module__KiSToW__button",
  "inverted": "styles-module-scss-module__KiSToW__inverted",
  "isNav": "styles-module-scss-module__KiSToW__isNav",
  "neutral": "styles-module-scss-module__KiSToW__neutral",
  "primary": "styles-module-scss-module__KiSToW__primary",
  "secondary": "styles-module-scss-module__KiSToW__secondary",
  "tertiary": "styles-module-scss-module__KiSToW__tertiary",
  "underline": "styles-module-scss-module__KiSToW__underline",
  "wrapper": "styles-module-scss-module__KiSToW__wrapper",
});
